import React, { createContext, useContext, useMemo } from 'react';
import { createStore, useStore } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

export interface HeaderState {
  renderProp?: React.ReactNode;
}

export const createHeaderStore = () => {
  return createStore<HeaderState>()(
    subscribeWithSelector(() => ({}))
  );
};

type HeaderStore = ReturnType<typeof createHeaderStore>;

const HeaderContext = createContext<HeaderStore | null>(null);

export const HeaderStateProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {

  const store = useMemo(() => createHeaderStore(), []);

  return (
    <HeaderContext.Provider value={store}>
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeaderStoreAPI = () => {
  const store = useContext(HeaderContext);
  if (!store) {
    throw new Error('useHeaderStoreAPI must be used within a HeaderStateProvider');
  }
  return store;
};


export const useHeaderStore = (): HeaderState => {
  const store = useHeaderStoreAPI();
  return useStore(store, (state) => state);
};


